import { styled } from "@mui/material";
import { KahunNavigationLogo } from "../../kahunNavigationLogo";
import { MobileView } from "../../../util/aKaunGeneralUtil";

export const KahunLogo = styled(KahunNavigationLogo)(({ theme }) => ({
  border: "none",
  "& svg": { margin: "auto" },
  marginRight: theme.spacing(1),
  background: "none",
  maxWidth: "130px",
  marginBottom: "0px",
  [theme.breakpoints.down(MobileView)]: {
    "& svg": {
      height: "16px",
      width: "auto",
      margin: 0,
    },
    margin: 0,
  },
}));
